import React from "react";
import "./BB8NavBar.scss";
import "./BB8Shared.scss";

const BB8NavBar = (props: any) => (
  <div className={"bb8-nav-bar-wrapper" + " " + props.className}>
    <div className={"bb8-nav-bar"}>
      <div className="bb8-title-wapper">
        <div className="bb8-title-img-wrapper">
          <img src={require("../assets/images/logo.svg")} alt="company logo" />
        </div>
        <h1 id={props.id}>{props.title}</h1>
      </div>
      {props.children}
    </div>
  </div>
);

export default BB8NavBar;
